
<div class="card-body">
  <table class="table table-border cell-border subcompact striped">
    <thead>
    <tr style="background-color:#3c6478">
      <th class="fg-white">
        {{'#' | translate}}
      </th>
      <th class="fg-white" *ngFor="let header of dataMapper"
          [ngClass]="{'focus-header': orderBy === currentCol(header)}"
          (click)="getItemHeaderToSort(header)">{{ header.header | translate }}</th>
    </tr>
    </thead>
    <tbody *ngIf="dataApi">
    <tr *ngFor="let row of dataApi | paginate:
                  { id: configComponent.idPagination, currentPage: page + 1,  itemsPerPage: size, totalItems: totalItems }; let i=index;"
        class="clickable" (click)="onSelect(row)" (dblclick)="onSelectDoubleClick(row)"
        [ngClass]="{'bg-gray': isSelected(row)}">
      <td>{{ i+1 }}</td>
      <td *ngFor="let key of dataMapper">
        <span *ngIf="key.type !== 'DATE'">
          {{ getFieldValue(row, key.field) }}
        </span>
        <span *ngIf="key.type === 'DATE'">
          {{ getFieldValue(row, key.field) | date: 'dd-MM-YYY : HH:mm:ss' }}
        </span>
      </td>
    </tr>
    </tbody>
  </table>
</div>
<div class="cell-md-12 p-0 m-0 text-center">
  <pagination-controls [id]="configComponent.idPagination"
                       (pageChange)="onChangePage($event)"
                       (pageBoundsCorrection)="onChangePage($event)" maxSize="5" directionLinks="true"
                       autoHide="true" responsive="true" previousLabel="{{'<<'|translate}}"
                       nextLabel="{{'>>'|translate}}"></pagination-controls>
</div>
